__turbopack_context__.v({
  "root": "styles-module-scss-module__rzeblq__root",
});
